const customStyles = {
  rows: {
    style: {
      backgroundColor: "#0d1635",
      color: "#FFFFFF",
    },
    highlightOnHoverStyle: {
      backgroundColor: "#0d1635",
      cursor: "pointer",
    },
    stripedStyle: {
      backgroundColor: "#0A1330",
    },
  },
  pagination: {
    style: {
      backgroundColor: "transparent",
      color: "#fff",
      minHeight: "56px",
    },
    pageButtonsStyle: {
      fill: "#000",
      "&:hover": {
        backgroundColor: "#000",
      },
      "&:disabled": {
        fill: "#ccc",
      },
    },
  },
  headCells: {
    style: {
      fontSize: "16px", // 🔹 Header font size
      fontWeight: "600", // optional
    },
  },
  cells: {
    style: {
      fontSize: "16px", // 🔹 Row font size
    },
  },
};

export default customStyles;
